import { restoreDocumentAPI } from "../services/DocuMateAPI";

class DocuMateRecycleBinService {
     restoreDocument = async (docQueueId: string) => {
            var res = await restoreDocumentAPI(docQueueId);
            return res;
        }
}

export default DocuMateRecycleBinService;